export default "https://cdn-static.gokick.com/assets/10f8238ac2c3e70096f19214fcd9b55856558067/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";